import { suggestionChipClasses } from './noteInstructions.styles';
import type { SuggestionChipsProps } from './noteInstructions.types';

/** One scrollable row of suggestions, so they never push the note up. */
export const SuggestionChips = ({ suggestions, disabled, onSelect }: SuggestionChipsProps) => {
  if (suggestions.length === 0) return null;
  return (
    <div className="mb-2 flex items-center gap-1.5 overflow-x-auto [scrollbar-width:none]">
      <span className="shrink-0 text-muted-foreground text-xs">Prófaðu:</span>
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          type="button"
          className={suggestionChipClasses}
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};
